import type { Vehicle } from '@kontor/shared';

/**
 * Kleines Vorschaubild des Hauptfotos in der Fahrzeugliste. Fahrzeuge ohne Foto zeigen nichts. Das Bild wird erst geladen, wenn die Zeile sichtbar wird, und der Browser
 * hält es kurz vor (der Server liefert es mit `max-age=300`). Es ist reine Zierde, der Name des Fahrzeugs steht daneben, deshalb bleibt der Alternativtext leer.
 */
export function VehicleThumb({ vehicle, small = false }: { vehicle: Pick<Vehicle, 'id' | 'mainImageId'>; small?: boolean }) {
  if (!vehicle.mainImageId) return null;
  return <img className={`fleet-thumb${small ? ' fleet-thumb--sm' : ''}`} src={`/api/v1/fleet/vehicles/${vehicle.id}/images/${vehicle.mainImageId}`} alt="" loading="lazy" decoding="async" width={small ? 40 : 64} height={small ? 30 : 48} />;
}
